import {SupplierBillList, SupplierBillRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {fmtAmt} from "../../../../components/utils/numbers";
import {dateToString} from "../../../../components/utils/dates";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {numSx} from "../tax_submission/labels";

export const SupplierBillListPage = () => {
    const apiManager = useApiManager();

    const listConfig: AppListConfig<SupplierBillList> = {
        title: "Facturas recibidas",
        onClick: "/app/admin/accounting/supplier-bill",
        headers: [
            {title: "Número", width: 110},
            {title: "Proveedor", width: 160},
            {title: "Descripción"},
            {title: "Fecha", width: 100},
            {title: "Vencimiento", width: 100},
            {title: "Base", align: "right", width: 100},
            {title: "IVA %", align: "right", width: 70},
            {title: "Total", align: "right", width: 110},
            {title: "Asiento", width: 90},
        ],
        decorator: (bean: SupplierBillList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
                    {bean.billNumber ?? "-"}
                </TableCell>
                <TableCell>{bean.supplier?.name}</TableCell>
                <TableCell>{bean.description ?? "-"}</TableCell>
                <TableCell>{dateToString(bean.issueDate)}</TableCell>
                <TableCell>{dateToString(bean.dueDate) || "-"}</TableCell>
                <TableCell align="right" sx={numSx}>{fmtAmt(bean.baseAmount)}</TableCell>
                <TableCell align="right" sx={numSx}>{bean.vatRate != null ? `${bean.vatRate} %` : "—"}</TableCell>
                <TableCell align="right" sx={{...numSx, fontWeight: 700}}>{fmtAmt(bean.totalAmount)}</TableCell>
                <TableCell sx={numSx}>
                    {bean.journalEntry?.entryNumber ?? <span style={{color: "#9ca3af"}}>Sin asiento</span>}
                </TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SupplierBillRestControllerApiFactory);
            return ctrl.pageSupplierBill(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
